<template>
  <b-row style="margin-bottom:30px">
    <b-col md="12">
      <b-card
        class="card-panel"
        :style="{
          backgroundColor: coloreSfondo,
          color: coloreTesto,
          borderColor: coloreBordo
        }"
      >
        <el-table
          ref="outputTable"
          :data="tableData"
          border
          height="300"
          style="width:100%;max-height:500px;min-height:500px;"
          highlight-current-row
          size="small"
          :row-class-name="tableRowClassName"
          @current-change="handleCurrentChange"
        >
          <el-table-column
            v-if="$store.getters.profiloUtente.prezzi"
            prop="prezzo"
            :label="uniTranslation('PHE695')"
          >
            <template slot-scope="scope">{{ scope.row.prezzo.toFixed(2) }}</template>
          </el-table-column>
          <el-table-column prop="geometriaDescrizioneLogo" :label="uniTranslation('PHE825')" />
          <el-table-column prop="percentualeAltaResa" :label="uniTranslation('PHE828') + ' [%]'" />
          <el-table-column prop="connessioni" :label="uniTranslation('PHE10186')" />
          <el-table-column prop="passaggi" :label="uniTranslation('PHE10056')" />
          <el-table-column prop="numeroDiPiastre" :label="uniTranslation('PHE729')" />
          <el-table-column
            v-if="$store.getters.typeOfPhe == 1"
            prop="spessore"
            :label="uniTranslation('PHE10057') + ' [' + getUmsShow(misureData['umSpessore']) + ']'"
          />

          <el-table-column
            prop="superficie"
            :label="uniTranslation('PHE599') + ' [' + getUmsShow(misureData['umSuperficie']) + ']'"
          >
            <template slot-scope="scope">{{ scope.row.superficie.toFixed(2) }}</template>
          </el-table-column>

          <el-table-column prop="delta" :label="uniTranslation('PHE10058') + ' [%]'">
            <template slot-scope="scope">{{ scope.row.delta.toFixed(2) }}</template>
          </el-table-column>

          <!-- <el-table-column
            prop="potenza"
            :label="uniTranslation('Q1189') + ' [' + misureData['umPotenza'] + ']'"
          >
            <template slot-scope="scope">{{ scope.row.potenza.toFixed(2) }}</template>
          </el-table-column>-->
          <el-table-column
            prop="perditeDiCaricoTotaliPrimario"
            :label="
              uniTranslation('PHE10059') +
                ' [' +
                getUmsShow(misureData['umPerditeDiCaricoTotaliPrimario']) +
                ']'
            "
          >
            <template slot-scope="scope">{{
              scope.row.perditeDiCaricoTotaliPrimario.toFixed(2)
            }}</template>
          </el-table-column>
          <el-table-column
            prop="perditeDiCaricoTotaliSecondario"
            :label="
              uniTranslation('PHE10060') +
                ' [' +
                getUmsShow(misureData['umPerditeDiCaricoTotaliSecondario']) +
                ']'
            "
          >
            <template slot-scope="scope">{{
              scope.row.perditeDiCaricoTotaliSecondario.toFixed(2)
            }}</template>
          </el-table-column>
          <el-table-column prop="ped" :label="uniTranslation('PED')" />
          <el-table-column
            v-if="true"
            prop="plateMaterialDescription"
            :label="uniTranslation('PHE580')"
          />
          <el-table-column
            prop="dimensioni"
            :label="uniTranslation('PHE10061') + ' [' + getUmsShow(misureData['umLunghezza']) + ']'"
          />

          <el-table-column label="">
            <template slot-scope="scope">
              <b-spinner v-show="scope.row.id == idLoad" label="Spinning"></b-spinner>
              <el-button-group>
                <el-button
                  v-show="scope.row.id == idVerifica"
                  size="mini"
                  class="fa fa-folder-open"
                  @click="dblClick(scope.row)"
                ></el-button>
                <el-button
                  v-show="scope.row.id == idVerifica && scope.row.hasWarnings"
                  size="mini"
                  class="fa fa-warning"
                  @click="showWarningClick(scope.row)"
                ></el-button>
              </el-button-group>
            </template>
          </el-table-column>
        </el-table>
      </b-card>
    </b-col>

    <b-modal v-model="showWarning" size="xl" centered hide-backdrop hide-header ok-only>
      <WarningsPanelNew :warnings="warningsList"></WarningsPanelNew>
    </b-modal>
  </b-row>
</template>

<script>
import { mapGetters } from "vuex";
import colorsService from "../../services/backend/colorsService";
import { Table, TableColumn } from "element-ui";
import jsonHelper from "../../shared/jsonHelper";
import { Button } from "element-ui";
import { ButtonGroup } from "element-ui";
import * as statuses from "../../store/modules/projectStore_Constants";
import projectServiceCipriani from "../../services/backendCipriani/accessoriesService";
import excelHelper from "@/shared/excelHelper";
import WarningsPanelNew from "@/components/shared/WarningsPanelNew.vue";

export default {
  components: {
    "el-table": Table,
    "el-table-column": TableColumn,
    "el-button": Button,
    "el-button-group": ButtonGroup,
    WarningsPanelNew
  },

  props: {
    parentPath: {
      type: String,
      required: true
    },
    localPath: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      path: null,
      idLoad: -1,
      idVerifica: -1,
      coloreSfondo: "",
      coloreTesto: "",
      coloreBordo: "",
      tableData: [],
      resultData: [],
      misureData: {
        umPerditeDiCaricoTotaliPrimario: "",
        umPerditeDiCaricoTotaliSecondario: "",
        umPotenza: ""
      },
      currentRow: null,
      dblClickRow: null,
      cacheData: [],
      //---------------------
      warningsList: null,
      showWarning: false,
      rigaWarning: null,
      //---------------------

      manualPlateMaterialSelection: true
    };
  },

  computed: {
    ...mapGetters(["projects", "getUmsShow"])
  },

  created: function() {
    if (this.parentPath && this.localPath) {
      this.path = this.parentPath + this.localPath;
    }
  },

  mounted() {
    var that = this;

    that.idLoad = -1;
    that.idVerifica = -1;
    that.cacheData = [];

    //colorsService.getColoriCard().then(function(data) {
    var colorList = colorsService.getColoriCard();
    that.coloreSfondo = colorList[0] + " !important";
    that.coloreTesto = colorList[2];
    that.coloreBordo = colorList[6];
    //});

    that.updateSelectionOutput();

    //that.idLoad = -1;
    //that.idVerifica = -1;
    //alert("sono qui");
    that.svuotaCache(this.tableData.length);

    /*  that.manualPlateMaterialSelection = !jsonHelper.getProperty(
      that.projects,
      that.parentPath + ".calculateWithAllPlateMaterial"
    );*/
    that.manualPlateMaterialSelection = !jsonHelper.getProperty(
      that.projects,
      that.parentPath + ".shoulder.calculateWithAllPlateMaterial"
    );

    that.$store.subscribe(function(mutation /*, state*/) {
      if (mutation.type === "refreshAll") {
        that.updateSelectionOutput();
      }
      /*   if (mutation.type === "changeProjectProperty") {
        that.manualPlateMaterialSelection = !jsonHelper.getProperty(
          that.projects,
          that.parentPath + ".calculateWithAllPlateMaterial"
        );
      }*/
    });
  },

  methods: {
    tableRowStyle({ row }) {
      if (row.hasWarnings === true) {
        return "background-color: rgb(250,210,001)";
      }
      if (row.id === this.idLoad || row.id === this.idVerifica) {
        return "background-color: rgb(164,183,193)";
      }
      return "background-color: white";
    },

    tableRowClassName({ row }) {
      if (row.hasWarnings === true) {
        return "resultgrid-warning-row";
      } else if (row.id === this.idLoad || row.id === this.idVerifica) {
        return "resultgrid-selected-row";
      } else {
        return "resultgrid-standard-row";
      }
    },

    updateSelectionOutput: function() {
      var that = this;

      this.tableData = jsonHelper.getProperty(that.projects, that.path + ".selectionOutput");
      this.misureData = jsonHelper.getProperty(that.projects, that.path + ".misureOutput");
      this.resultData = jsonHelper.getProperty(that.projects, that.parentPath + ".results");
    },

    impostaDatiModello(val) {
      var that = this;
      //this.$store.dispatch("impostaDatiModelloDaSelezione", val);
      //alert(val.id);

      if (this.resultData) {
        if (val.id < this.resultData.length) {
          var selP = this.resultData[val.id];
          if (selP) {
            that.idLoad = val.id;
            that.idVerifica = -1;

            var Progetto = that.projects[that.parentPath];

            // CACHE
            var i = that.idLoad;
            if (that.cacheData[i] != null) {
              let prj = JSON.parse(JSON.stringify(that.cacheData[i]));
              that.aggiornaProgetto(prj, Progetto, selP);
            } else {
              var pts = {};
              pts.project = that.GetSimplexProject(); // clone senza le griglie dei risultati
              pts.scambiatore = selP;
              projectServiceCipriani.impostascambiatoreselezionato(pts, that.idLoad).then(data => {
                var tmpP = JSON.parse(JSON.stringify(Progetto));
                tmpP.calculationId = data.calculationId;
                tmpP.top = data.top;
                tmpP.left = data.left;
                tmpP.right = data.right;
                tmpP.bottom = data.bottom;
                tmpP.shoulder = data.shoulder;
                that.cacheData[i] = tmpP; //JSON.parse(JSON.stringify(data)); //Memorizzo lo stato iniziale di ritorno!!!
                // aggiorna maschera risultati progetto
                that.aggiornaProgetto(tmpP, Progetto, selP);
              });
            }
          }
        }
      }
    },
    svuotaCache(count) {
      var that = this;

      that.cacheData = [];
      for (var i = 1; i <= count; i++) {
        that.cacheData.push(null);
      }
    },
    aggiornaProgetto(data, P, selP) {
      var that = this;
      that.warningsList = null;

      if (data != null && data != undefined) {
        data.selectionOutput.selectionOutput = P.selectionOutput.selectionOutput;
        data.results = P.results;
        data.innerProject = selP;

        that.warningsList = selP.warnings; //Andrea 30.09.2020

        that.$store.dispatch("loadProject", {
          projectId: data.projectId,
          project: data
        });

        if (data.calculated) {
          that.idVerifica = that.idLoad;
          that.$store.dispatch("refreshAllData");
        }
      }

      that.idLoad = -1;
    },
    GetSimplexProject() {
      var P = this.projects[this.parentPath];
      var deepClone_P = JSON.parse(JSON.stringify(P));
      deepClone_P.innerProject = null;
      deepClone_P.selectionOutput.selectionOutput = [];
      deepClone_P.results = [];
      return deepClone_P;
    },
    cloneProject() {
      var P = this.projects[this.parentPath];
      var deepClone_P = JSON.parse(JSON.stringify(P));
      return deepClone_P;
    },
    exportSelectionGrid() {
      var that = this;
      var expArr = [];

      //alert(JSON.stringify(this.tableData));

      that.tableData.forEach(x => {
        var myX = {};

        if (that.$store.getters.profiloUtente.prezzi) {
          myX.prezzo = ("" + x.prezzo.toFixed(2)).replace(".", ",");
        }
        myX.geometriaDescrizione = x.geometriaDescrizioneLogo;
        myX.percentualeAltaResa = ("" + x.percentualeAltaResa).replace(".", ",");
        myX.connessioni = x.connessioni;
        myX.passaggi = " " + x.passaggi;
        myX.numeroDiPiastre = ("" + x.numeroDiPiastre).replace(".", ",");

        if (that.$store.getters.typeOfPhe == 1) {
          myX.spessore = ("" + x.spessore).replace(".", ",");
        }

        myX.superficie = ("" + x.superficie.toFixed(2)).replace(".", ",");
        myX.delta = ("" + x.delta.toFixed(2)).replace(".", ",");

        myX.perditeDiCaricoTotaliPrimario = (
          "" + x.perditeDiCaricoTotaliPrimario.toFixed(2)
        ).replace(".", ",");
        myX.perditeDiCaricoTotaliSecondario = (
          "" + x.perditeDiCaricoTotaliSecondario.toFixed(2)
        ).replace(".", ",");
        myX.ped = x.ped;
        myX.dimensioni = ("" + x.dimensioni).replace(".", ",");

        console.log(myX);
        expArr.push(myX);
      });

      /*
        List Price	          uniTranslation('PHE695')
        GEOMETRY	          uniTranslation('PHE825')
        plates A [%]              uniTranslation('PHE828') + ' [%]'
        Connections	          uniTranslation('PHE10186')
        No. of passes             uniTranslation('PHE10056')
        No. of plates             uniTranslation('PHE729')
        Thickness [mm]            uniTranslation('PHE10057') + ' [' + misureData['umSpessore'] + ']'
        Heat transert area [m2]   uniTranslation('PHE599') + ' [' + misureData['umSuperficie'] + ']'
        Total oversizing [%]      uniTranslation('PHE10058') + ' [%]'
        PD (cold side) [kPa]      uniTranslation('PHE10059') +' [' + misureData['umPerditeDiCaricoTotaliPrimario'] + ']'
        PD (hot side) [kPa]       uniTranslation('PHE10060') + ' [' + misureData['umPerditeDiCaricoTotaliSecondario'] + ']'  
        PED                       uniTranslation('PED')
        WxHxL [mm]                uniTranslation('PHE10061') + ' [' + misureData['umLunghezza'] + ']'
      */
      var Header = [
        that.uniTranslation("PHE695"),
        that.uniTranslation("PHE825"),
        that.uniTranslation("PHE828") + " [%]",
        that.uniTranslation("PHE10186"),
        that.uniTranslation("PHE10056"),
        that.uniTranslation("PHE729"),
        that.uniTranslation("PHE10057") + " [" + that.misureData["umSpessore"] + "]",
        that.uniTranslation("PHE599") + " [" + that.misureData["umSuperficie"] + "]",
        that.uniTranslation("PHE10058") + " [%]",
        that.uniTranslation("PHE10059") +
          " [" +
          that.misureData["umPerditeDiCaricoTotaliPrimario"] +
          "]",
        that.uniTranslation("PHE10060") +
          " [" +
          that.misureData["umPerditeDiCaricoTotaliSecondario"] +
          "]",
        that.uniTranslation("PED"),
        that.uniTranslation("PHE10061") + " [" + that.misureData["umLunghezza"] + "]"
      ];

      // alert("sono qui");
      excelHelper.csvExportWithHeader(expArr, String("SelectionExportation.csv"), Header);
    },
    showWarningClick(val) {
      this.showWarning = true;
      this.rigaWarning = val;
      //alert(val);
    },
    dblClick(val) {
      this.dblClickRow = val;

      /*
      alert("that.calculationTypeValue_postSele = " + val.idCalculationTypeValue);
      alert("that.calculationModeValue_postSele = " + val.idCalculationModeValue);
      alert("that.typeOfPheValue_postSele = " + val.idTypeOfPheValue);
      alert("that.designStandardValue_postSele = " + val.idDesignStandardValue);
      alert("that.productLineValue_postSele = " + val.idProductLineValue);
      alert("that.designPressureValue_postSele = " + val.idDesignPressureValue);
      alert("that.platesMaterialValue_postSele = " + val.idPlatesMaterialValue);
      alert("that.gasketsMaterialValue_postSele = " + val.idGasketsMaterialValue);
      alert("that.framesMaterialValue_postSele = " + val.idFramesMaterialValue);
      alert("that.platesThicknessValue_postSele = " + val.idPlatesThickness);
      alert("that.sizeGeometryValue_postSele = " + val.idSizeGeometry);
      alert("that.typeGeometryValue_postSele = " + val.idTypeGeometry);
      */

      this.$store.dispatch("ensureStatus", statuses.ARRIVO_DA_SELEZIONE);
      this.$store.dispatch("ensureStatus", statuses.VERIFICA);

      val.passaInVerificaDaSelezione = true;

      this.$store.dispatch("impostaDatiSpallaDaSelezione", val);

      this.$emit("passaInVerifica", val);
    },

    handleCurrentChange(val) {
      if (val) {
        this.impostaDatiModello(val);
      }
    }
  }
};
</script>

<style>
.el-table .resultgrid-warning-row {
  background: rgb(250, 210, 001) !important;
}

.el-table .resultgrid-selected-row td {
  background: rgb(164, 183, 193) !important;
}

.el-table .resultgrid-standard-row td {
  background: white !important;
}
</style>
